(ns ycweb.app.website.registry.view
  (:require
   #?@(:cljs
       [[ajax.core :as ajax]])
   [rum.core :as rum]
   [ycweb.app.website.cart.model :as cart.model]
   [ycweb.app.website.registry.common :as arm.cmn]
   [ycweb.app.website.website :as website]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(defn registry-closed [app-atom user partner]
  [:div
   {:class (u/bem :yc-section [:large])}
   [:div.u-block-center.u-max-width-640
    (feedback/feedback-raw :error
      {:title "This Registry is closed"
       :description
       [(str "Sorry, but "
          (cond
            (and (u/presence (:user/first-name user)) (u/presence (:partner/first-name partner)))
            (str (:user/first-name user) " and " (:partner/first-name partner) " have already closed this Registry")

            (u/presence (:user/first-name user))
            (str (:user/first-name user) " has already closed this Registry")

            :else
            "this Registry is already closed")
          " and you can no longer buy gifts off it. Give them a shout to see if there's anything else they'd like from us or buy them a ")
        [:a.text-link
         (urlstate/href-props app-atom "gift-vouchers")
         "gift voucher."]]})]])

(defn guest-add-voucher [app-atom selected-item-atom]
  #?(:cljs
     (let [process-atom (cmn/process-cursor app-atom)
           {:registry/keys [can-edit? client-order]} (cmn/curact process-atom [:registry])
           new-cart-enabled (cmn/curact app-atom [:features :new-cart])]
       (when
         (or
           (not can-edit?)
           (js/confirm "This is your own registry. Are you sure you want to pay for something in your registry?"))
         (let [selected-item @selected-item-atom
               {:voucher/keys [price variation-id]} selected-item
               invalid-total? (when price (> price 20000))]

           (cond
             invalid-total?
             (toaster/open-toast app-atom :error "Maximum of R20 000 allowed. Contact us for larger amounts." {})

             (or (nil? price) (<= price 0))
             (toaster/open-toast app-atom :error "Please enter a voucher value." {})

             (< price 5)
             (toaster/open-toast app-atom :error "Minimum voucher amount is R5." {})

             ;; Use new cart API via cart model abstraction
             new-cart-enabled
             (let [voucher-data
                   {:amount (* price 100) ;; Convert to cents
                    :qty 1
                    :forregistry_uuid (str (:ent/uuid client-order))}

                   complete-fn
                   (fn [response]
                     (toaster/close-toast app-atom)
                     (grid/open-modal app-atom :web.registry/guest-add-item-modal
                       {:config
                        {:title "Voucher has been added"
                         :order-total
                         (str "R"
                           (u/currency-format
                             (get-in @app-atom [:cart-summary :totals :total])))}})

                     (swap! selected-item-atom assoc :voucher/price 0))]

               (toaster/open-toast app-atom :processing "Adding voucher to cart" {})
               (cart.model/add-voucher app-atom voucher-data complete-fn))

             ;; Use legacy PHP endpoint
             :else
             (let [form-data
                   {:SPA true
                    :formid "form-voucher"
                    :registryorderid (:client-order/id selected-item)
                    :createitemifneeded 1
                    :forregistryitemid ""
                    :forregistryvariationid variation-id
                    (str "price[" variation-id "]") price
                    (str "qty[" variation-id "]") 1}
                   data (js/FormData.)]

               (doseq [[k v] form-data]
                 (.append data (name k) v))

               (toaster/open-toast app-atom :processing "Adding voucher to cart" {})

               (ajax/POST
                 "/registry.htm?action=addtoguestcart&overrideincludes=blank"
                 {:body data
                  :response-format :json
                  :keywords? true
                  :handler
                  (fn [res]
                    (cond
                      (:success res)
                      (do
                        (toaster/close-toast app-atom)
                        (grid/dispatch-action app-atom :web.registry/guest-add-to-cart
                          {:res res
                           :title :voucher})
                        (swap! selected-item-atom assoc :voucher/price 0)
                        (grid/dispatch-action app-atom :web.common/cart-mini-qty {}))

                      :else
                      (do
                        (toaster/close-toast app-atom)
                        (grid/open-modal app-atom :web.registry/guest-add-item-error-modal
                          {:config
                           {:title "Voucher cannot be added"}}))))
                  :error-handler
                  (fn [res]
                    (toaster/open-toast app-atom :error "Item not added to cart" {}))
                  :timeout 60000}))))))))

(defmethod grid/action :web.registry/guest-add-to-cart [app-atom config _]
  #?(:cljs
     (let [pop-up-title
           (if (= :voucher (:title config))
             "Voucher has been added"
             "Item has been added")]
       (ajax/GET "/cart.htm?action=miniqty"
         {:response-format :json
          :keywords? true
          :handler
          (fn [response]
            (swap! app-atom assoc :cart-summary response)
            (grid/open-modal app-atom :web.registry/guest-add-item-modal
              {:config
               {:title pop-up-title
                :order-total (:total (:res config))}}))}))))

(rum/defc voucher < rum/reactive [app-atom]
  (let [voucher-atom (rum/cursor-in (cmn/process-cursor app-atom) [:voucher])]
    [:div
     {:class (u/bem :yc-section [:medium])}
     [:div.form.cta-block.u-block-center.u-max-width-720.u-margin-top-40
      (headings/heading "Buy them a Yuppiechef Gift Voucher"
        {:type :h3
         :size :tiny
         :center true
         :flush true})
      [:p.yc-paragraph.u-text-center
       "Simply enter an amount of your choice and they can use it towards anything they want."]
      [:div.u-block-center.u-max-width-480
       {:class (u/bem :flex-grid-group [:valign-middle])}
       [:div
        {:class (u/bem :flex-grid-block [:s-1-2])}
        [:div.flex-grid-content
         [:div.text-input-wrapper
          (forms/input-raw ""
            (rum/cursor voucher-atom :voucher/price)
            {:type :currency
             :icon true})
          [:i.text-input-icon]]]]
       [:div
        {:class (u/bem :flex-grid-block [:s-1-2])}
        [:div.flex-grid-content
         (buttons/button-web "Add to cart"
           {:type :submit
            :on-click
            (fn [e]
              (.preventDefault e)
              (guest-add-voucher app-atom voucher-atom))
            :style :primary
            :size :default
            :full true})]]]]]))

(defn registry-open [app-atom registry]
  (let [{:item-line/keys [user]
         :registry/keys [can-edit? current-registry? message partner client-order allow-vouchers?]}
        registry

        {:client-order/keys [items id]}
        client-order

        edit-mode? false]
    [:div
     (when can-edit?
       [:div.u-block-center.u-max-width-160.u-margin-bottom-20
        (buttons/button-web "Back to Edit Mode"
          (merge
            (urlstate/href-props app-atom "registry" "edit" {:uuid (:ent/uuid registry)})
            {:type :button
             :style :secondary
             :size :small
             :full true
             :class :button--rounded}))])

     (when
       (and can-edit? (not current-registry?))
       [:div.u-block-center.u-max-width-640
        (feedback/feedback-raw :warning
          {:title "You are currently managing another Registry"
           :description
           ["This registry belongs to you, but you're currently managing another Registry. Would you like to "
            [:a (urlstate/href-props app-atom "registry" "edit" {:uuid (:ent/uuid registry)}) "edit this registry?"]]})])

     [:div
      {:class (u/bem :yc-section [:standard-underline])}
      [:div.yc-intro-text
       [:p.yc-paragraph (u/nl2br message)]]]
     [:div
      {:class (u/bem :yc-section [:medium-underline])}
      (headings/heading
        (str "Buying "
          (cond
            (and (u/presence (:user/first-name user)) (u/presence (:partner/first-name partner)))
            (str (:user/first-name user) " and " (:partner/first-name partner))

            (u/presence (:user/first-name user))
            (:user/first-name user))
          " a gift?")
        {:type :h3
         :size :tiny
         :center true})
      [:div.u-block-center.u-max-width-240
       (buttons/button-web "How It Works"
         {:href "/help.htm?action=article&id=43"
          :style :secondary
          :size :default
          :full true
          :class :js-mfp-open-url
          :custom-attrs
          {:target_url "/help.htm?action=article&id=43&overrideincludes=blank"
           :data-title "<b>Buying</b> a Registry Gift"
           :data-content-wrapper-class "yc-simple-text"}})]]
     (arm.cmn/order-table app-atom edit-mode? items)
     (when allow-vouchers? (voucher app-atom))]))

(rum/defc registry-view < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        site-admin (cmn/has-permission? app-atom "SiteAdmin")
        registry-client-order (cmn/curact process-atom [:registry :registry/client-order])
        {:item-line/keys [user]
         :registry/keys [closed? partner] :as registry} (cmn/curact process-atom [:registry])]

    [:div
     (arm.cmn/registry-banner app-atom registry)
     (when site-admin
       [:div.u-block-center.u-max-width-160.u-margin-bottom-40
        (buttons/button-web "View on Dashboard"
          (merge
            (urlstate/href-props app-atom "admin/purchases" "" {:id (:client-order/id registry-client-order)})
            {:target "_blank"
             :style :primary}))])

     (cond
       closed?
       (registry-closed app-atom user partner)

       :else
       (registry-open app-atom registry))
     (toaster/loading-overlay app-atom :web.registry/view)]))

(defmethod flow/render-screen :web.registry/view [app-atom _]
  (website/screen-wrapper app-atom
    (registry-view app-atom)
    {:pagetype :registry}))

(defmethod t/transition-open :web.registry/view [app-atom _ params]
  (toaster/open-overlay app-atom :web.registry/view)
  (comms/ajax-get :web.registry/view (select-keys params [:uuid])))

(defmethod comms/receive :web.registry/view [app-atom view]
  (swap! (cmn/process-cursor app-atom) assoc
    :registry (:registry view)
    :voucher (:voucher view)
    :categories
    {:categories (:categories view)
     :group-items-by-key "purchased"})
  (toaster/close-overlay app-atom :web.registry/view))